const ArchWindowDevice = {
    id: 'clipPathArch',
    path: 'M136.5 1.7998C210.893 1.7998 271.2 62.1072 271.2 136.5V402.2H1.7998V136.5C1.79981 62.1072 62.1073 1.7998 136.5 1.7998Z',
    relativePath: 'M 0.5 0 C 0.78 0 1 0.15 1 0.34 V 1 H 0 V 0.34 C 0 0.15 0.22 0 0.5 0 Z',
    relativePathToSquare: 'M 0.50 0.00 C 1.00 0.00 1.00 0.00 1.00 0.00 V 1.00 H 0.00 V 0.00 C 0.00 0.00 0.00 0.00 0.50 0.00 Z',
    viewBox: '0 0 273 404',
    aspectRatio: 273 / 404,
};
const RectangleWindowDevice = {
    id: 'clipPathRectangle',
    path: 'M40 1.5H240C261.263 1.5 278.5 18.737 278.5 40V365C278.5 386.263 261.263 403.5 240 403.5H40C18.737 403.5 1.5 386.263 1.5 365V40C1.5 18.737 18.737 1.5 40 1.5Z',
    relativePath: 'M 0.14 0 H 0.86 C 0.94 0 1 0.04 1 0.10 V 0.90 C 1 0.96 0.94 1 0.86 1 H 0.14 C 0.06 1 0 0.96 0 0.90 V 0.10 C 0 0.04 0.06 0 0.14 0 Z',
    relativePathToSquare: 'M 0 0.00 H 1 C 1 0.00 1 0.00 1 0.00 V 1.00 C 1 1.00 1 1.00 1 1.00 H 0 C 0 1.00 0 1.00 0 1.00 V 0.00 C 0 0.00 0 0.00 0 0.00 Z',
    viewBox: '0 0 280 405',
    aspectRatio: 280 / 405,
};
const PentagonWindowDevice = {
    id: `clipPathPentagon`,
    path: 'M283 407V61.649L139.307 2L2 61.649V407H283Z',
    relativePath: 'M 1 1 V 0.15 L 0.49 0 L 0 0.15 V 1 H 1 Z',
    relativePathToSquare: 'M 1 1 V 0 L 0.49 0 L 0 0 V 1 H 1 Z',
    viewBox: '0 0 285 409',
    aspectRatio: 285 / 409,
};
export function getWindowDevice(variant) {
    switch (variant) {
        case 'arch':
            return ArchWindowDevice;
        case 'rectangle':
            return RectangleWindowDevice;
        case 'pentagon':
            return PentagonWindowDevice;
        default:
            console.warn(`Unknown window device variant: ${variant}`);
            return ArchWindowDevice;
    }
}
